import { KulionerMerchant } from "@/domain/entities/Kulioner";

export type KulionerTotals = {
  totalMerchant: number;
  totalMerchantCompleted: number;
  totalProduct: number;
  totalProductCompleted: number;
  totalPieces: number;
  totalActualPieces: number;
  totalTransaction: number;
  totalTransactionCompleted: number;
};

export function computeKulionerTotals(
  merchantsInput: KulionerMerchant[] | undefined | null
): KulionerTotals {
  const totals: KulionerTotals = {
    totalMerchant: 0,
    totalMerchantCompleted: 0,
    totalProduct: 0,
    totalProductCompleted: 0,
    totalPieces: 0,
    totalActualPieces: 0,
    totalTransaction: 0,
    totalTransactionCompleted: 0
  };

  const merchants = Array.isArray(merchantsInput) ? merchantsInput : [];
  totals.totalMerchant = merchants.length;

  for (const merchant of merchants) {
    if (merchant?.isPurchased) totals.totalMerchantCompleted += 1;

    const products = Array.isArray(merchant?.products) ? merchant.products : [];
    totals.totalProduct += products.length;

    for (const p of products) {
      if (p?.isQuantityUpdated) totals.totalProductCompleted += 1;
      const price = Number(p?.price) || 0;
      const qty = Number(p?.quantity) || 0;
      const actualQty = Number(p?.actualQuantity) || 0;

      totals.totalPieces += qty;
      totals.totalActualPieces += actualQty;
      totals.totalTransaction += price * qty;
      totals.totalTransactionCompleted += price * actualQty;
    }
  }

  return totals;
}
